// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Montserrat_e67545', '__Montserrat_Fallback_e67545'","fontStyle":"normal"},"className":"__className_e67545"};